import Banner from "./Banner";
import Contact from "./Contact";
import AboutUs from "./AboutUs";
import Supporting from "./Supporting";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import WebLayout from "layout/webLayout.js";
import HowDonationWorks from "./HowDonationWorks";
import { getProjects } from "appState/project/projectSlice";
import JoinWaitlistModal from "layout/modal/JoinWaitlist";

const HomePageSections = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <WebLayout>
      <JoinWaitlistModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <Banner />
      <AboutUs />
      <Supporting />
      <HowDonationWorks />
      <Contact />
    </WebLayout>
  );
};

export default HomePageSections;
